import '../assets/css/bookmarks.css'
import '../assets/css/listinvoices.css'
import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom"; // pour permettre d'ajouter un param dans l'url
import Logo from '../assets/img/logo-pinkW.svg';
import { Article } from '../views/article';
import Loader from '../assets/img/loader.svg';


export function NewFacture(props) {
    const [choiceRadio, setChoiceRadio] = useState("")
    const [choiceDevis, setChoiceDevis] = useState("")
    const devisIds = props.dataDevisFactures.filter(filtre => filtre.gsx$type.$t.includes("1 Devis"))
    
    const factureIds = props.dataDevisFactures.filter(filtre => !filtre.gsx$type.$t.includes("1 Devis"))

    const googleSpreadClient = 'https://spreadsheets.google.com/feeds/list/1QreeDxWPsP9s2FzzvygdpYDFRKaPGPFojNfy_RPR4MI/1/public/values?alt=json' // Si les champs sont ok
    const [dataClient, setSetDataClient] = useState([])
    const [load, setLoad] = useState(false)
    const [addNewLine, setAddNewLine] = useState(0)

    const [items, setItems] = useState([]);
    const [tva, setTva] = useState(0);
    const [remise, setRemise] = useState(0);
    const [itemsCompl, setItemsCompl] = useState([]);
    const [itemName, setItemName] = useState("");
    const [itemComment, setItemComment] = useState("");
    const [itemJour, setItemJour] = useState(0);
    const [itemTjm, setItemTjm] = useState(450);

    const [itemName1, setItemName1] = useState("");
    const [itemJour1, setItemJour1] = useState(0);
    const [itemTjm1, setItemTjm1] = useState(450);


    const [refresh, setRefresh] = useState(0)
    const [taches, setTaches] = useState("");
    const [commentaires, setCommentaires] = useState("");
    const [jours, setJours] = useState("0");
    const [tjm, setTjm] = useState("0");

    const [taches1, setTaches1] = useState("");
    const [jours1, setJours1] = useState("0");
    const [tjm1, setTjm1] = useState("0");



    let tachesArray = []
    let commentairesArray = []
    let joursArray = []
    let tjmArray = []

    let tachesArray1 = []
    let joursArray1 = []
    let tjmArray1 = []

 
    function addItem(e) {
        setItems([
            ...items,
            {
                id: items.length,
                name: itemName,
                comment: itemComment,
                jour: itemJour,
                tjm: itemTjm,
                status: "add"
            }
        ]);
        setItemName("");
        setItemComment("");
        setItemJour(0);
        setItemTjm(450);
        setRefresh(refresh + 1)

    };



    function addItemCompl(e) {
        setItemsCompl([
            ...itemsCompl,
            {
                id: itemsCompl.length,
                name: itemName1,
                jour: itemJour1,
                tjm: itemTjm1,
                status: "add"
            }
        ]);
        setItemName1("");
        setItemJour1(0);
        setItemTjm1(450);
        setRefresh(refresh + 1)
        console.log(itemsCompl)

    };
    function deleteTask(item) {
        console.log(item)
        item.status = "remove"
        setRefresh(refresh - 1)

    }

   
    useEffect(() => {
        setItems([...items])
        items.filter(filter => filter.status.includes("add")).map(item => (
            tachesArray.push(item.name),
            commentairesArray.push(item.comment),
            joursArray.push(item.jour),
            tjmArray.push(item.tjm)
        ))
      tachesArray = tachesArray.join(";")
      commentairesArray = commentairesArray.join(";")
       joursArray = joursArray.join(";")
       tjmArray = tjmArray.join(";")
        setTaches(tachesArray)
        setCommentaires(commentairesArray)
        setJours(joursArray)
        setTjm(tjmArray)
    }, [refresh])
    

    useEffect(() => {
        setItemsCompl([...itemsCompl])
        itemsCompl.filter(filter => filter.status.includes("add")).map(item => (
            tachesArray1.push(item.name),
            joursArray1.push(item.jour),
            tjmArray1.push(item.tjm)
        ))
       tachesArray1 = tachesArray1.join(";")
        joursArray1 = joursArray1.join(";")
        tjmArray1 = tjmArray1.join(";")
        setTaches1(tachesArray1)
        setJours1(joursArray1)
        setTjm1(tjmArray1)

    }, [refresh])
   

    useEffect(() => {
        fetch(googleSpreadClient)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.feed.entry) {
                        let dataFilter = result.feed.entry
                        function compare(a, b) {
                            if (a.gsx$raisonsociales.$t < b.gsx$raisonsociales.$t) { return -1; }
                            if (a.gsx$raisonsociales.$t > b.gsx$raisonsociales.$t) { return 1; }
                            return 0;
                        };
                        setSetDataClient(dataFilter.sort(compare))
                    } else { setSetDataClient('empty') } return
                },
                (error) => { setSetDataClient('error') })
        return () => setSetDataClient([])
    }, [])

    function bigestId(type) {
        let numbers = ""
        for (let i = 0; i < type.length; i++) {
            numbers += parseInt(type[i].gsx$iddocument.$t) + ","
        }
        let removeLastEl = numbers.slice(0, numbers.length - 1).split(",")
        let idNumberConvert = removeLastEl.map(function (x) {
            return parseInt(x, 10);
        });
        const result = Math.max(...idNumberConvert)
        const addResult = String(result + 1)
        let id = ""
        for (let i = 0; i < 4; i++) {
            id += "0"
        }
        let slideId = id.slice(addResult.length, id.length)
        return slideId + addResult
    }

    console.log("_____________________")
    console.log(items.jour)
    console.log(jours)



  
            




    return (
        props.modalNew == true ?
            <main className="modalView newFacture">
                <div className="modal-wrap">
                    <div className="modal-content">
                        <div className="close-btn" onClick={(e) => {
                            props.setModalNew(false);
                            setChoiceRadio("")
                            setChoiceDevis("")
                        }}>×</div>
                        <article>
                            {load === true ? <div className="loader"><img src={Loader} alt="loader" /></div> : null}
                            <h1 className="titleModal">Créer {choiceRadio === "Devis" ? "un devis" :
                                choiceRadio === "Facture d'acompte" ? "une facture d'acompte" :
                                    choiceRadio === "Facture" ? "une facture" : "un document"}</h1>

                            <form name="submit-to-google-sheet" onSubmit={(event) => {
                                event.preventDefault()
                                const scriptURL = 'https://script.google.com/macros/s/AKfycbxVSZ87RgBSiHktg_BdUrhVGJ55rmtntD1qEMsmBkDjdjj-FQlUNxKVCo-H-lRi2205LA/exec'
                                const form = document.forms['submit-to-google-sheet']

                                setLoad(true)
                                fetch(scriptURL, { method: 'POST', body: new FormData(form) })
                                    .then(response => {
                                        // console.log("ok POST")
                                        props.setRefresh(refresh + 1)
                                        props.setModalNew(false)
                                        setLoad(false)
                                        setChoiceRadio("")
                                        setChoiceDevis("")
                                        setItems([])
                                        setItemsCompl([])
                                    })
                                    .catch(error => {
                                        // console.log("nok")
                                    })
                            }
                            }
                            >
                                <div>
                                    <input type="radio" onClick={(e) => { setChoiceRadio("Devis"); }} id="devis1" name="type" value="1 Devis"></input>
                                    <label for="devis1" >Devis</label>
                                    <input type="radio" onClick={(e) => { setChoiceRadio("Facture d'acompte"); }} id="acompte1" name="type" value="2 Facture d'acompte"></input>
                                    <label for="acompte1">Facture d'acompte</label>
                                    <input type="radio" onClick={(e) => { setChoiceRadio("Facture"); }} id="facture1" name="type" value="3 Facture"></input>
                                    <label for="facture1">Facture</label>
                                </div>
                                {/*---------------------------------------DEVIS---------------------------------------------------*/}
                                {/*-----------------------------------------------------------------------------------------------*/}
                                {choiceRadio === "Devis" ?
                                    <>
                                        <div>
                                            <div>
                                                <label for="codeid">Numéro</label>
                                                <div>
                                                    <input type="text" name="codeid" id="codeid" required readOnly value={"D" + new Date().getFullYear()}></input>
                                                    <div>-</div>
                                                    <input type="number" name="iddocument" id="iddocument" required readOnly value={bigestId(devisIds)}></input>

                                                </div>

                                            </div>


                                            <div>
                                                <label for="dateToday">Date <span></span></label>
                                                <input type="text" name="date" id="dateToday" required value={new Date().toLocaleDateString()}></input>
                                            </div>
                                            <div>
                                                <label for="client">Client</label>
                                                <select name="client" id="client" required>
                                                    <option value="" disabled selected>Sélectionner un client</option>
                                                    {dataClient.map((item) => {
                                                        return (
                                                            <option value={item.gsx$raisonsociales.$t}>{item.gsx$raisonsociales.$t}</option>
                                                        )
                                                    })}
                                                </select>
                                            </div>
                                            <div className="hidden">
                                                <input type="text" name="nbrelances" id="nbrelances" required readOnly value="0" />
                                                <input type="text" name="statut" id="statut" required readOnly value="En attente" />
                                                <input type="text" name="tauxacompte" id="tauxacompte" required readOnly value="30" />
                                                <input type="text" name="taches" id="taches" required readOnly value={taches} />
                                                <input type="text" name="comentairesbytasks" id="comentairesbytasks" required readOnly value={commentaires} />
                                                <input type="text" name="tjm" id="tjm" required readOnly value={tjm} />
                                                <input type="text" name="jours" id="jours" required readOnly value={jours} />
                                                

                                            </div>
                                        </div>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th>
                                                        <span>TVA</span>
                                                        <input type="number" name="tauxtva" id="tauxtva" required defaultValue={tva} min="0" max="100" onChange={(e) => { setTva(e.target.value) }}/>
                                                    </th>
                                                    <th>
                                                        <span>Remise</span>
                                                        <input type="number" name="tauxremise" id="tauxremise" required defaultValue={remise} min="0" max="100" onChange={(e) => { setRemise(e.target.value) }}/>
                                                    </th>
                                                    <th></th>
                                                    <th></th>
                                                </tr>
                                                <tr>
                                                    <th>Tâches</th>
                                                    <th>nb Jours</th>
                                                    <th>TJM</th>
                                                    <th>Total</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {items
                                                    .filter(filter => filter.status.includes("add"))
                                                    .map(item => (
                                                        <tr key={item.id}>
                                                            <td><p>{item.name}</p><p>{item.comment}</p></td>
                                                            <td>{item.jour} </td>
                                                            <td>{item.tjm}</td>
                                                            <td>
                                                                <span>{props.formatEUro((item.jour * item.tjm))}</span>

                                                            </td>
                                                            <td><button className="remove" action="" method="" type="button" onClick={(e) => { deleteTask(item) }}><span>×</span></button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    
                                                    

                                                    <tr className="total">
                                                    <td>Total</td>
                                                    <td>{props.calcParse(jours)}</td>
                                                    <td></td>
                                                    <td>
                                                    {props.formatEUro(props.calcDevisTotalHT(jours, tjm, remise))}</td>
                                                    <td></td>

                                                </tr>
                                                
                                                {/*
                                                <tr className="new">
                                                    <td><p>{itemName}</p><p>{itemComment}</p></td>
                                                    <td>{itemJour}</td>
                                                    <td>{itemTjm}</td>
                                                    <td><span>{itemJour * itemTjm}</span></td>
                                                    <td></td>
                                                </tr>
                                            */}

                                                <tr>
                                                    <td>
                                                        <input name="item" type="text" placeholder="Tâche" value={itemName} onChange={e => setItemName(e.target.value)} />
                                                        <input name="itemComment" type="text" placeholder="Commentaire" value={itemComment} onChange={e => setItemComment(e.target.value)} />
                                                    </td>
                                                    <td>
                                                        <input name="item" type="number" placeholder="Jour" value={itemJour} onChange={e => setItemJour(e.target.value)} />
                                                    </td>
                                                    <td>
                                                        <input name="item" type="number" placeholder="TJM" value={itemTjm} onChange={e => setItemTjm(e.target.value)} />

                                                    </td>
                                                    <td>{props.formatEUro((itemJour * itemTjm))}</td>
                                                    <td >

                                                        <button className="add" type="button" onClick={e => addItem(e)}><span>+</span></button>


                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </> : null}
                                {/*---------------------------------------FACTURE D ACOMPTE--------------------------------------*/}
                                {/*-----------------------------------------------------------------------------------------------*/}
                                {choiceRadio === "Facture d'acompte" ?
                                    <>
                                        <div className="formTypeAcompte">
                                            <div>
                                                <label for="codeid">Numéro</label>
                                                <div>
                                                    <input type="text" name="codeid" id="codeid" required readOnly value={"F" + new Date().getFullYear()}></input>
                                                    <div>-</div>
                                                    <input type="number" name="iddocument" id="iddocument" required readOnly value={bigestId(factureIds)}></input>
                                                </div>
                                            </div>
                                            <div>
                                                <label for="dateToday">Date <span></span></label>
                                                <input type="text" name="date" id="dateToday" required value={new Date().toLocaleDateString()}></input>
                                            </div>
                                            <div>
                                                <label for="client">Devis</label>

                                                <select name="iddevisChoose" id="iddevisChoose" onChange={(e) => { setChoiceDevis(e.target.value) }} required>
                                                    <option value="" disabled selected>Sélectionner un devis</option>
                                                    {props.dataDevisFactures
                                                        .filter(filtre => filtre.gsx$type.$t.includes("1 Devis"))
                                                        .map((item) => {
                                                            return (
                                                                <option value={item.gsx$iddocument.$t}>{item.gsx$codeid.$t}-{item.gsx$iddocument.$t} | {item.gsx$client.$t} | {props.formatEUro(props.calcDevisTotalHT(item.gsx$jours.$t, item.gsx$tjm.$t, item.gsx$tauxremise.$t))}</option>
                                                            )
                                                        })}
                                                </select>
                                            </div>
                                            </div>



                                            <table className="searchDevis">
                                                <thead>
                                                    <tr>
                                                        <th>n°</th>
                                                        <th>Client</th>
                                                        <th>Date</th>
                                                        <th>Nb j.</th>
                                                        <th>Total</th>
                                                        <th>Remise</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {props.dataDevisFactures
                                                        .filter(filtre => filtre.gsx$iddocument.$t.includes(choiceDevis))
                                                        .filter(filtre => filtre.gsx$type.$t.includes("1 Devis"))
                                                        .map((item) => {
                                                            return (
                                                                <>

                                                                    <tr>
                                                                        <td>{item.gsx$codeid.$t}-{item.gsx$iddocument.$t}</td>
                                                                        <td>{item.gsx$client.$t}</td>
                                                                        <td>{item.gsx$date.$t}</td>
                                                                        <td>{item.gsx$jours.$t.length > 0 ? props.calcParse(item.gsx$jours.$t) + " j" : "---"}</td>
                                                                        <td>{props.formatEUro(props.calcDevisTotalHT(item.gsx$jours.$t, item.gsx$tjm.$t, item.gsx$tauxremise.$t))}</td>
                                                                        <td>{item.gsx$tauxremise.$t}%</td>
                                                                    </tr>
                                                                    {choiceDevis != "" ?
                                                                        <div className="hidden">
                                                                            <input type="text" name="iddevis" id="iddevis" readOnly value={item.gsx$codeid.$t + "-" + item.gsx$iddocument.$t} />
                                                                            <input type="text" name="nbrelances" id="nbrelances" readOnly value="0" />
                                                                            <input type="text" name="statut" id="statut" required value="En attente" />
                                                                            <input type="text" name="tauxacompte" id="tauxacompte" readOnly value="30" />
                                                                            <input type="text" name="taches" id="tache" readOnly value={"Acompte de 30% sur la commande " + item.gsx$codeid.$t + "-" + item.gsx$iddocument.$t} />
                                                                            <input type="text" name="jours" id="jours" readOnly value={item.gsx$jours.$t} />
                                                                            <input type="text" name="tjm" id="tjm" readOnly value={item.gsx$tjm.$t} />
                                                                            <input type="text" name="type" id="type" readOnly value={item.gsx$type.$t} />
                                                                            <input type="text" name="tauxremise" id="tauxremise" readOnly value={item.gsx$tauxremise.$t} />
                                                                            <input type="text" name="client" id="client" readOnly value={item.gsx$client.$t} />
                                                                            <input type="text" name="tauxtva" id="tauxtva" readOnly value={item.gsx$tauxtva.$t} />
                                                                            <input type="text" name="comentairesbytasks" id="comentairesbytasks" readOnly value={item.gsx$comentairesbytasks.$t} />

                                                                           </div>

                                                                        : null}



                                                                </>
                                                            )
                                                        })}
                                                </tbody>
                                            </table>
                                        


                                    </>
                                    : null}
                                {/*---------------------------------------FACTURE---------------------------------------------------*/}
                                {/*-----------------------------------------------------------------------------------------------*/}
                                {choiceRadio === "Facture" ?
                                      <>
                                      <div className="formTypeAcompte">
                                          <div>
                                              <label for="codeid">Numéro</label>
                                              <div>
                                                  <input type="text" name="codeid" id="codeid" required readOnly value={"F" + new Date().getFullYear()}></input>
                                                  <div>-</div>
                                                  <input type="number" name="iddocument" id="iddocument" required readOnly value={bigestId(factureIds)}></input>
                                              </div>
                                          </div>
                                          <div>
                                              <label for="dateToday">Date <span></span></label>
                                              <input type="text" name="date" id="dateToday" required value={new Date().toLocaleDateString()}></input>
                                          </div>
                                          <div>
                                              <label for="client">Devis</label>

                                              <select name="iddevisChoose" id="iddevisChoose" onChange={(e) => { setChoiceDevis(e.target.value) }} required>
                                                  <option value="" disabled selected>Sélectionner un devis</option>
                                                  {props.dataDevisFactures
                                                      .filter(filtre => filtre.gsx$type.$t.includes("1 Devis"))
                                                      .map((item) => {
                                                          return (
                                                              <option value={item.gsx$iddocument.$t}>{item.gsx$codeid.$t}-{item.gsx$iddocument.$t} | {item.gsx$client.$t} | {props.formatEUro(props.calcDevisTotalHT(item.gsx$jours.$t, item.gsx$tjm.$t, item.gsx$tauxremise.$t))}</option>
                                                          )
                                                      })}
                                              </select>
                                          </div>
                                          </div>
                                          <div className="hidden">
                                          
                                          </div>



                                          <table className="searchDevis">
                                              <thead>
                                                  <tr>
                                                      <th>n°</th>
                                                      <th>Client</th>
                                                      <th>Date</th>
                                                      <th>Nb j.</th>
                                                      <th>Total</th>
                                                      <th>Remise</th>


                                                  </tr>
                                              </thead>
                                              <tbody>
                                                  {props.dataDevisFactures
                                                      .filter(filtre => filtre.gsx$iddocument.$t.includes(choiceDevis))
                                                      .filter(filtre => filtre.gsx$type.$t.includes("1 Devis"))
                                                      .map((item) => {
                                                          return (
                                                              <>

                                                                  <tr>
                                                                      <td>{item.gsx$codeid.$t}-{item.gsx$iddocument.$t}</td>
                                                                      <td>{item.gsx$client.$t}{taches1}</td>
                                                                      <td>{item.gsx$date.$t}</td>
                                                                      <td>{item.gsx$jours.$t.length > 0 ? props.calcParse(item.gsx$jours.$t) + " j" : "---"}</td>
                                                                      <td>{props.formatEUro(props.calcDevisTotalHT(item.gsx$jours.$t, item.gsx$tjm.$t, item.gsx$tauxremise.$t))}</td>
                                                                      <td>{item.gsx$tauxremise.$t}%</td>
                                                                  </tr>
                                                                  {choiceDevis != "" ?
                                                                      <div className="hidden">
                                                                      
                                                                            
                                                                          <input type="text" name="iddevis" id="iddevis" readOnly value={item.gsx$codeid.$t + "-" + item.gsx$iddocument.$t} />
                                                                          <input type="text" name="nbrelances" id="nbrelances" readOnly value="0" />
                                                                          <input type="text" name="statut" id="statut" required value="En attente" />
                                                                          <input type="text" name="tauxacompte" id="tauxacompte" readOnly value="30" />
                                                                          <input type="text" name="taches" id="tache" readOnly value={item.gsx$taches.$t} />
                                                                          <input type="text" name="jours" id="jours" readOnly value={item.gsx$jours.$t} />
                                                                          <input type="text" name="tjm" id="tjm" readOnly value={item.gsx$tjm.$t} />
                                                                          <input type="text" name="type" id="type" readOnly value={item.gsx$type.$t} />
                                                                          <input type="text" name="tauxremise" id="tauxremise" readOnly value={item.gsx$tauxremise.$t} />
                                                                          <input type="text" name="client" id="client" readOnly value={item.gsx$client.$t} />
                                                                          <input type="text" name="tauxtva" id="tauxtva" readOnly value={item.gsx$tauxtva.$t} />
                                                                          <input type="text" name="comentairesbytasks" id="comentairesbytasks" readOnly value={item.gsx$comentairesbytasks.$t} />
                                                                 
                                                                 <input type="text" name="tachescomplementaires" id="tachescomplementaires" readOnly value={taches1} />
                                                                       <input type="text" name="tjmcomplementaires" id="tjmcomplementaires" readOnly value={tjm1} />
                                                                      <input type="text" name="jourscomplementaires" id="jourscomplementaires" readOnly value={jours1} />
                                                                           
                                                                      
                                                                      
                                                                    
                                                                         
                                                                            </div>

                                                                      : null}



                                                              </>
                                                          )
                                                      })}
                                              </tbody>
                                          </table>














                                          <table>
                                            <thead>
                                                <tr>
                                                    <th>Tâches</th>
                                                    <th>nb Jours</th>
                                                    <th>TJM</th>
                                                    <th>Total</th>
                                                    <th></th>
                                                    
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {itemsCompl
                                                    .filter(filter => filter.status.includes("add"))
                                                    .map(item => (
                                                        <tr key={item.id}>
                                                            <td><p>{item.name}</p><p>{item.comment}</p></td>
                                                            <td>{item.jour} </td>
                                                            <td>{item.tjm}</td>
                                                            <td>
                                                                <span>{props.formatEUro((item.jour * item.tjm))}</span>

                                                            </td>
                                                            <td><button className="remove" action="" method="" type="button" onClick={(e) => { deleteTask(item) }}><span>×</span></button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                               <tr className="total">
                                                    <td>Total des interventions supplémentaires</td>
                                                    <td>{props.calcParse(jours1)}</td>
                                                    <td></td>
                                                    <td>{props.formatEUro(props.calcDevisTotalHT(jours1, tjm1, 0))}</td>
                                                    <td></td>

                                                </tr>
                                                {/* 
                                                <tr className="new">
                                                    <td><p>{itemName1}</p></td>
                                                    <td>{itemJour1}</td>
                                                    <td>{itemTjm1}</td>
                                                    <td><span>{itemJour1 * itemTjm1}</span></td>
                                                    <td></td>
                                                </tr>*/}


                                                <tr>
                                                    <td>
                                                        <input name="item" type="text" placeholder="Tâche" value={itemName1} onChange={e => setItemName1(e.target.value)} />
                                                         </td>
                                                    <td>
                                                        <input name="item" type="number" placeholder="Jour" value={itemJour1} onChange={e => setItemJour1(e.target.value)} />
                                                    </td>
                                                    <td>
                                                        <input name="item" type="number" placeholder="TJM" value={itemTjm1} onChange={e => setItemTjm1(e.target.value)} />

                                                    </td>
                                                    <td>{props.formatEUro((itemJour * itemTjm))}</td>
                                                    <td>

                                                        <button className="add" type="button" onClick={e => addItemCompl(e)}><span>+</span></button>


                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                            </tfoot>
                                        </table>
                                      


                                  </>
                                    : null}


                                <div><button action="" method="" type="submit">Ajouter {choiceRadio === "Devis" ? "de devis" :
                                    choiceRadio === "Facture d'acompte" ? "cette facture d'acompte" :
                                        choiceRadio === "Facture" ? "cette facture" : "ce document"} à la liste<span>+</span></button></div>
                            </form>

                        </article>
                    </div>
                </div>
                <div class="bg-overlay" onClick={(e) => {
                    props.setModalNew(false);
                    setChoiceRadio("")
                    setChoiceDevis("")
                }}></div>
            </main>
            : null
    )
}